import { render, staticRenderFns } from "./create-new-store.vue?vue&type=template&id=ff8a88a6&scoped=true"
import script from "./create-new-store.vue?vue&type=script&lang=js"
export * from "./create-new-store.vue?vue&type=script&lang=js"
import style0 from "./create-new-store.vue?vue&type=style&index=0&id=ff8a88a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff8a88a6",
  null
  
)

export default component.exports